import { Button } from 'antd';
import { DATA_SECURITY_DASHBOARD } from '@sonar-software/sonar-ts-constants';
import React from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

export interface HideDetectedButtonProps {
	hideDetected?: boolean;
	onHideDetectedChange: (value: boolean) => void;
}

export const HideDetectedButton: React.FC<HideDetectedButtonProps> = ({
	hideDetected = false,
	onHideDetectedChange
}) =>
	<Button
		className='hide-detected-apps-checkbox'
		icon={ hideDetected ? <EyeInvisibleOutlined /> : <EyeOutlined /> }
		onClick={ () => onHideDetectedChange(!hideDetected) }
		type={ hideDetected ? 'primary' : 'default' }>
		{ hideDetected ?
			DATA_SECURITY_DASHBOARD.SHOW_DETECTED_APPS :
			DATA_SECURITY_DASHBOARD.HIDE_DETECTED_APPS }
	</Button>;

